import { render, staticRenderFns } from "./deleteStaffCollectedProduct.vue?vue&type=template&id=87fdf9c4"
import script from "./deleteStaffCollectedProduct.vue?vue&type=script&lang=js"
export * from "./deleteStaffCollectedProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports